import React, { useState, useEffect } from "react";
import { hidecolumn } from "../common/RemoveColumn";

export default function CardButton(props) {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    setSelectedOptions([{ label: "All", value: "*" }, ...options]);
  }, []);
  const options = [
    { label: "ACW", value: "ACW", index: 2 },
    { label: "AHT", value: "AHT", index: 3 },
    { label: "API contacts handled", value: "API contacts handled", index: 4 },
    { label: "Abandoned", value: "Abandoned", index: 5 },
    { label: "Active", value: "Active", index: 6 },
    {
      label: "After contact work time",
      value: "After contact work time",
      index: 7,
    },
    { label: "Agent hung up", value: "Agent hung up", index: 8 },
    { label: "Agents non-response", value: "Agents non-response", index: 9 },
    { label: "Availability", value: "Availability", index: 10 },
    { label: "Available", value: "Available", index: 11 },
    {
      label: "Avg API connecting time",
      value: "Avg API connecting time",
      index: 12,
    },
    { label: "Avg abandon time", value: "Avg abandon time", index: 13 },
    {
      label: "Avg callback connecting time",
      value: "Avg callback connecting time",
      index: 14,
    },
    { label: "Avg hold time", value: "Avg hold time", index: 15 },
    {
      label: "Avg incoming connecting time",
      value: "Avg incoming connecting time",
      index: 16,
    },
    {
      label: "Avg interaction and hold time",
      value: "Avg interaction and hold time",
      index: 17,
    },
    { label: "Avg interaction time", value: "Avg interaction time", index: 18 },
    {
      label: "Avg outbound connecting time",
      value: "Avg outbound connecting time",
      index: 19,
    },
    {
      label: "Avg queue answer time",
      value: "Avg queue answer time",
      index: 20,
    },
    {
      label: "Callback contacts handled",
      value: "Callback contacts handled",
      index: 21,
    },
    { label: "Contacts consulted", value: "Contacts consulted", index: 22 },
    { label: "Error", value: "Error", index: 23 },
    { label: "Handled", value: "Handled", index: 24 },
    { label: "Handled in", value: "Handled in", index: 25 },
    { label: "Handled out", value: "Handled out", index: 26 },
    { label: "Hold abandons", value: "Hold abandons", index: 27 },
    { label: "In queue", value: "In queue", index: 28 },
    { label: "Max Queued", value: "Max Queued", index: 29 },
    { label: "NPT", value: "NPT", index: 30 },
    { label: "Occupancy", value: "Occupancy", index: 31 },
    { label: "Oldest", value: "Oldest", index: 32 },
    { label: "On contact", value: "On contact", index: 33 },
    { label: "Online", value: "Online", index: 34 },
    { label: "Queued", value: "Queued", index: 35 },
    { label: "SL 120 secs", value: "SL 120 secs", index: 36 },
    { label: "SL 15 secs", value: "SL 15 secs", index: 37 },
    { label: "SL 180 secs", value: "SL 180 secs", index: 38 },
    { label: "SL 20 secs", value: "SL 20 secs", index: 39 },
    { label: "SL 240 secs", value: "SL 240 secs", index: 40 },
    { label: "SL 25 secs", value: "SL 25 secs", index: 41 },
    { label: "SL 30 secs", value: "SL 30 secs", index: 42 },
    { label: "SL 300 secs", value: "SL 300 secs", index: 43 },
    { label: "SL 45 secs", value: "SL 45 secs", index: 44 },
    { label: "SL 60 secs", value: "SL 60 secs", index: 45 },
    { label: "SL 600 secs", value: "SL 600 secs", index: 46 },
    { label: "SL 90 secs", value: "SL 90 secs", index: 47 },
    { label: "Scheduled", value: "Scheduled", index: 48 },
    { label: "Staffed", value: "Staffed", index: 49 },
    { label: "Tranfered in", value: "Tranfered in", index: 50 },
    {
      label: "Tranfered in from Queue",
      value: "Tranfered in from Queue",
      index: 51,
    },
    { label: "Tranfered out", value: "Tranfered out", index: 52 },
    {
      label: "Tranfered out from Queue",
      value: "Tranfered out from Queue",
      index: 53,
    },
  ];

  const [pre, setPre] = useState([]);

  function onChange(value, event) {
    if (event.action === "select-option" && event.option.value === "*") {
      console.log(this.options);
      options.map((u) => hidecolumn(u.index, props.k, event.action));
      this.setState(this.options);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      this.setState([]);
      options.map((u) => hidecolumn(u.index, props.k, event.action));
    } else if (event.action === "deselect-option") {
      this.setState(value.filter((o) => o.value !== "*"));
      console.log(value.length);
      console.log(options.length);
      const result = options.filter(
        ({ index: id1 }) => !value.some(({ index: id2 }) => id2 === id1)
      );
      result.map((u) => hidecolumn(u.index, props.k, event.action));
      console.log("res", result);
    } else if (value.length === this.options.length - 1) {
      //console.log(event.option)
      hidecolumn(event.option.index, props.k, event.action)
      this.setState(this.options);
    } else {
      this.setState(value);
      hidecolumn(event.option.index, props.k, event.action)
      
    }
  }

  return (
    <>
      <div className="col-auto d-flex flex-wrap flex-md-nowrap align-items-center w-100 position-static datatable-col">
        <h3 className="card-title align-items-center m-0 position-relative z-index-1">
          <span className="card-label fw-bolder fs-3 m-0 text-primary">
            {props.queueName}
          </span>
          {/* <input
                    className="card-label fw-bolder fs-3 m-0 text-primary"
                    value={u["Queue Name"]}
                    disabled={edit}
                  /> */}

          <a
            href="#!"
            //onClick={enableEdit}
            className="d-inline-block ms-3 btn btn-light-primary btn-sm px-3 py-2"
          >
            <span className="svg-icon svg-icon-primary svg-icon-4 me-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                  <rect x={0} y={0} width={24} height={24} />
                  <path
                    d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                    fill="#000000"
                    fillRule="nonzero"
                    transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "
                  />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x={5}
                    y={20}
                    width={15}
                    height={2}
                    rx={1}
                  />
                </g>
              </svg>
            </span>
          </a>
        </h3>
        <div className="d-flex align-items-center toolbar-datatable">
          <p className="m-0">Time Range: Trailing previous 2 hours</p>
          <button
            className="btn btn-light btn-sm px-3 py-2 mx-3"
            data-bs-toggle="modal"
            data-bs-target="#settings-modal"
          >
            <span className="svg-icon svg-icon-dark svg-icon-2 m-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                  <rect x={0} y={0} width={24} height={24} />
                  <path
                    d="M18.6225,9.75 L18.75,9.75 C19.9926407,9.75 21,10.7573593 21,12 C21,13.2426407 19.9926407,14.25 18.75,14.25 L18.6854912,14.249994 C18.4911876,14.250769 18.3158978,14.366855 18.2393549,14.5454486 C18.1556809,14.7351461 18.1942911,14.948087 18.3278301,15.0846699 L18.372535,15.129375 C18.7950334,15.5514036 19.03243,16.1240792 19.03243,16.72125 C19.03243,17.3184208 18.7950334,17.8910964 18.373125,18.312535 C17.9510964,18.7350334 17.3784208,18.97243 16.78125,18.97243 C16.1840792,18.97243 15.6114036,18.7350334 15.1896699,18.3128301 L15.1505513,18.2736469 C15.008087,18.1342911 14.7951461,18.0956809 14.6054486,18.1793549 C14.426855,18.2558978 14.310769,18.4311876 14.31,18.6225 L14.31,18.75 C14.31,19.9926407 13.3026407,21 12.06,21 C10.8173593,21 9.81,19.9926407 9.81,18.75 C9.80552409,18.4999185 9.67898539,18.3229986 9.44717599,18.2361469 C9.26485393,18.1556809 9.05191298,18.1942911 8.91533009,18.3278301 L8.870625,18.372535 C8.44859642,18.7950334 7.87592081,19.03243 7.27875,19.03243 C6.68157919,19.03243 6.10890358,18.7950334 5.68746499,18.373125 C5.26496665,17.9510964 5.02757002,17.3784208 5.02757002,16.78125 C5.02757002,16.1840792 5.26496665,15.6114036 5.68716991,15.1896699 L5.72635306,15.1505513 C5.86570889,15.008087 5.90431906,14.7951461 5.82064513,14.6054486 C5.74410223,14.426855 5.56881236,14.310769 5.3775,14.31 L5.25,14.31 C4.00735931,14.31 3,13.3026407 3,12.06 C3,10.8173593 4.00735931,9.81 5.25,9.81 C5.50008154,9.80552409 5.67700139,9.67898539 5.76385306,9.44717599 C5.84431906,9.26485393 5.80570889,9.05191298 5.67216991,8.91533009 L5.62746499,8.870625 C5.20496665,8.44859642 4.96757002,7.87592081 4.96757002,7.27875 C4.96757002,6.68157919 5.20496665,6.10890358 5.626875,5.68746499 C6.04890358,5.26496665 6.62157919,5.02757002 7.21875,5.02757002 C7.81592081,5.02757002 8.38859642,5.26496665 8.81033009,5.68716991 L8.84944872,5.72635306 C8.99191298,5.86570889 9.20485393,5.90431906 9.38717599,5.82385306 L9.49484664,5.80114977 C9.65041313,5.71688974 9.7492905,5.55401473 9.75,5.3775 L9.75,5.25 C9.75,4.00735931 10.7573593,3 12,3 C13.2426407,3 14.25,4.00735931 14.25,5.25 L14.249994,5.31450877 C14.250769,5.50881236 14.366855,5.68410223 14.552824,5.76385306 C14.7351461,5.84431906 14.948087,5.80570889 15.0846699,5.67216991 L15.129375,5.62746499 C15.5514036,5.20496665 16.1240792,4.96757002 16.72125,4.96757002 C17.3184208,4.96757002 17.8910964,5.20496665 18.312535,5.626875 C18.7350334,6.04890358 18.97243,6.62157919 18.97243,7.21875 C18.97243,7.81592081 18.7350334,8.38859642 18.3128301,8.81033009 L18.2736469,8.84944872 C18.1342911,8.99191298 18.0956809,9.20485393 18.1761469,9.38717599 L18.1988502,9.49484664 C18.2831103,9.65041313 18.4459853,9.7492905 18.6225,9.75 Z"
                    fill="#000000"
                    fillRule="nonzero"
                    opacity="0.3"
                  />
                  <path
                    d="M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
            </span>
          </button>

          <button className="btn btn-light btn-sm px-3 py-2">
            <span className="svg-icon svg-icon-dark svg-icon-2 m-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                  <polygon points="0 0 24 0 24 24 0 24" />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x={11}
                    y={5}
                    width={2}
                    height={14}
                    rx={1}
                  />
                  <path
                    d="M6.70710678,12.7071068 C6.31658249,13.0976311 5.68341751,13.0976311 5.29289322,12.7071068 C4.90236893,12.3165825 4.90236893,11.6834175 5.29289322,11.2928932 L11.2928932,5.29289322 C11.6714722,4.91431428 12.2810586,4.90106866 12.6757246,5.26284586 L18.6757246,10.7628459 C19.0828436,11.1360383 19.1103465,11.7686056 18.7371541,12.1757246 C18.3639617,12.5828436 17.7313944,12.6103465 17.3242754,12.2371541 L12.0300757,7.38413782 L6.70710678,12.7071068 Z"
                    fill="#000000"
                    fillRule="nonzero"
                  />
                </g>
              </svg>
            </span>
          </button>

          <button className="btn btn-light btn-sm px-3 py-2 mx-3">
            <span className="svg-icon svg-icon-dark svg-icon-2 m-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                  <g
                    transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)"
                    fill="#000000"
                  >
                    <rect x={0} y={7} width={16} height={2} rx={1} />
                    <rect
                      opacity="0.3"
                      transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
                      x={0}
                      y={7}
                      width={16}
                      height={2}
                      rx={1}
                    />
                  </g>
                </g>
              </svg>
            </span>
          </button>
        </div>
      </div>
    </>
  );
}
